module.exports = __webpack_public_path__ + "static/media/background-header.5c2cb8f2.jpg";